let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("5zDuS"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("fJjZJ")]).then(() => parcelRequire('8d4o6'));